<template>
  <fragment>
    <li @click="run" v-if="showLinkEventModal">
      <v-icon left color="light-blue">ter-paperclip</v-icon>
      Připojení události
    </li>
  </fragment>
</template>
<script>
import {mapGetters} from "vuex";
import {includes} from "lodash";
import {hzsCategoryIds} from "@/store/modules/events";

export default {
  name: 'map-pair-context-menu',
  props: [
    'data',
  ],
  computed: {
    isActive() {
      return !this.isObjectActive && this.isActiveEvent && this.event.id > 0 && this.data;
    },
    ...mapGetters('events', {
      isActiveEvent: 'isActiveEvent',
      event: 'getActiveEvent',
    }),
    showLinkEventModal() {
      return this.isActiveEvent && includes(hzsCategoryIds, this.event.eventCategoryId) && includes(this.$store.state.auth.user.groups, 'COIS');
    },
  },
  methods: {
    run() {
      this.$store.commit('events/SET_SHOW_LINK_EVENT_MODAL', true);
    },
  },
}
</script>
